export {ShortcutComponent} from './shortcut.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/shortcut/index.ts